<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M18.7149 13.1798C15.0566 11.8249 12.1731 8.94138 10.8182 5.28305C10.7329 5.05148 10.4048 5.05148 10.3185 5.28305C8.96358 8.94138 6.08005 11.8249 2.42172 13.1798C2.19015 13.2651 2.19015 13.5932 2.42172 13.6795C6.08005 15.0344 8.96355 17.9179 10.3185 21.5762C10.4038 21.8078 10.7318 21.8078 10.8182 21.5762C12.1731 17.9179 15.0566 15.0344 18.7149 13.6795C18.9465 13.5942 18.9465 13.2661 18.7149 13.1798Z"
      fill="currentcolor"
    />
    <path
      d="M21.6861 5.27575C20.313 4.76894 19.2313 3.68725 18.7244 2.31399C18.6929 2.22867 18.5679 2.22867 18.5375 2.31399C18.0307 3.68715 16.949 4.76884 15.5757 5.27575C15.4904 5.30723 15.4904 5.43216 15.5757 5.46263C16.9489 5.96944 18.0306 7.05113 18.5375 8.4244C18.569 8.50971 18.6939 8.50971 18.7244 8.4244C19.2312 7.05124 20.3129 5.96955 21.6861 5.46263C21.7714 5.43115 21.7714 5.30622 21.6861 5.27575Z"
      fill="currentcolor"
    />
  </svg>
</template>
